var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent, Fragment } from "react";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage } from "@irati/utils/lang";
import getId from "@irati/utils/id";
import DateHeader from "../DateHeader";
import { StyledStatementItem, StyledHr, ShowMoreButton } from "./styled";
var StatementItemDetail = /** @class */ (function (_super) {
    __extends(StatementItemDetail, _super);
    function StatementItemDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatementItemDetail.prototype.render = function () {
        var _a = this.props, results = _a.results, paginationCount = _a.paginationCount, onShowMoreClick = _a.onShowMoreClick, load = _a.load, canLoadMore = _a.canLoadMore, cursor = _a.cursor, id = _a.id;
        return (React.createElement(React.Fragment, null,
            results.map(function (_a) {
                var date = _a.date, data = _a.data;
                var key = date.format("YYYY-MM-DD");
                return (React.createElement(Fragment, { key: key },
                    React.createElement(StyledHr, null),
                    React.createElement(DateHeader, { id: getId("date-header_" + key, id), date: date }),
                    data.map(function (statementItem) { return (React.createElement(StyledStatementItem, { id: getId("statement-item_" + statementItem.uuid, id), statementItem: statementItem, key: statementItem.uuid })); })));
            }),
            React.createElement(Loading, { load: load }),
            canLoadMore && cursor && (React.createElement(ShowMoreButton, { id: id, onClick: onShowMoreClick },
                React.createElement(FormattedMessage, { id: "wallet.statementItems.showMoreButton.text", values: { count: paginationCount } })))));
    };
    return StatementItemDetail;
}(PureComponent));
export default StatementItemDetail;
